module.exports = __webpack_public_path__ + "media/images/img-secondcarrier-6-0026f67e.jpg";